export function initializeSelect2(element, value = false) {
    element.parent().find('.select2-container').remove();
    element.select2({
        theme: "bootstrap"
    });
    if (value) {
        element.val(value).trigger('change');
    }
}
export function initializeSelect2FromAjax(element, valueId = false, valueText = false) {
    element.parent().find('.select2-container').remove();
    bpFieldInitSelect2FromAjaxElement(element, valueId, valueText);
}

function bpFieldInitSelect2FromAjaxElement(element, valueId = false, valueText = false) {
    var form = element.closest('form');
    var $placeholder = element.attr('data-placeholder');
    var $minimumInputLength = element.attr('data-minimum-input-length');
    var $dataSource = element.attr('data-data-source');
    var $method = element.attr('data-method');
    var $includeAllFormFields = element.attr('data-include-all-form-fields') == 'false' ? false : true;
    var $allowClear = element.attr('data-column-nullable') == 'true' ? true : false;
    var $dependencies = JSON.parse(element.attr('data-dependencies'));
    var $ajaxDelay = element.attr('data-ajax-delay');
    var $company_id = element.attr('data-user-company-id');
    $(element.find('option:not([data-select2-id=""])')).remove();

    $(element).select2({
        theme: 'bootstrap',
        multiple: false,
        placeholder: $placeholder,
        minimumInputLength: $minimumInputLength,
        allowClear: $allowClear,
        dropdownParent: false,
        ajax: {
            url: $dataSource,
            type: $method,
            dataType: 'json',
            delay: $ajaxDelay,
            data: function (params) {
                if ($includeAllFormFields) {
                    return {
                        user_company: $company_id,
                        dependencies: $dependencies,
                        q: params.term, // search term
                        form: form.serializeArray() // all other form inputs
                    };
                } else {
                    let filteredFormData = form.serializeArray().filter(field => $dependencies.includes(field.name));
                    return {
                        dependencies: $dependencies,
                        form: filteredFormData,
                        q: params.term, // search term
                    };
                }
            },
            processResults: function (data, params) {
                params.page = 1;
                var result = {
                    results: $.map(data, function (item) {
                        return {
                            text: item['value'],
                            id: item['id']
                        }
                    }),
                };
                return result;
            },
            cache: true
        },
    });
    $(element).append('<option value="' + valueId + '">' + valueText + '</option>');
    element.val(valueId).trigger("change");
}
